export const PRE_REVEAL_RAW_DEFAULTS = {
    speed: 1.5,
    scale: 0.5,
};

export const shaderChunks = {
    uniforms: () => ({
        uPreRevealRawSpeed: { value: PRE_REVEAL_RAW_DEFAULTS.speed },
        uPreRevealRawScale: { value: PRE_REVEAL_RAW_DEFAULTS.scale },
    }),
    funcs: /* glsl */ `
        uniform float uPreRevealRawSpeed;
        uniform float uPreRevealRawScale;

        #ifndef GLSL_PRE_REVEAL_RAW_NOISE
        #define GLSL_PRE_REVEAL_RAW_NOISE

        // Texture-based domain warp
        // float preRevealRawNoise(sampler2D noiseTexture, vec2 uv, float time, float speed, float scale) {
        //     float t = time * speed;
        //     vec2 p = uv * scale;
        //
        //     vec2 warpOffset = vec2(cos(t * 0.5), sin(t * 0.5)) * 0.5;
        //     vec2 warp = texture2D(noiseTexture, p + warpOffset).rg * 2.0 - 1.0;
        //     p += warp * 0.18;
        //
        //     vec2 sampleOffset = vec2(sin(t * 0.65 + 1.3), cos(t * 0.75 + 2.1)) * 0.08;
        //     return texture2D(noiseTexture, p + sampleOffset).r;
        // }

        float preRevealRawWaveNoise(vec2 uv, float time, float speed, float scale) {
            float t = time * speed;
            vec2 p = uv * scale;

            float wave1 = sin(p.x * 3.0 + t * 0.9) * cos(p.y * 2.5 - t * 0.7);
            float wave2 = sin(p.x * 5.0 - t * 0.6 + 1.3) * sin(p.y * 4.0 + t * 0.8);
            float wave3 = cos(p.x * 2.0 + p.y * 3.0 + t * 0.5);
            float wave4 = cos(p.x * 6.5 + t * 1.1) * cos(p.y * 5.5 - t * 0.4 + 2.1);

            float noise = wave1 * 0.35 + wave2 * 0.3 + wave3 * 0.2 + wave4 * 0.15;
            noise = noise * 0.5 + 0.5;

            // noise = (noise - 0.5) * 1.8 + 0.5;
            noise = smoothstep(0.3, 0.7, noise) * 1.5;

            return noise;
        }

        #endif

        vec3 preRevealRaw(vec2 uv, sampler2D uNoise, float time, vec3 color1, vec3 color2) {
            vec2 uvNoise = uv * vec2(1.0, 2.0);
            float noise = preRevealRawWaveNoise(uvNoise, time, uPreRevealRawSpeed, uPreRevealRawScale);
            // float noise = preRevealRawNoise(uNoise, uvNoise, time, uPreRevealRawSpeed, uPreRevealRawScale);

            // return mix(color1, color2, noise);
            return vec3(noise);
        }

        vec3 preRevealRaw(vec2 vUv, sampler2D uNoise, float time) {
            return preRevealRaw(vUv, uNoise, time, uPreRevealColor1, uPreRevealColor2);
        }
    `,
};
